import React from "react";
import "./Spinner.css";

interface SpinnerProps {
    height?: string;
}

const Spinner: React.FC<SpinnerProps> = ({height = "100vh"}) => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: height,
            }}
        >
            <div className="spinner"></div>
        </div>
    );
};

export default Spinner;